import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import AccountMessageForm from './AccountMessageForm';
import { MessageList, QuestionList } from './messages';

const AccountMessages = ({
  messages,
  questions,
  messagesFilter,
  onSave,
  isLoading,
  isLoadingQ,
  onFilterChange,
  t
}) => (
  <React.Fragment>
    <div className="padded">
      <h2>{t('Nahrať nové správy')}</h2>
      <AccountMessageForm
        onSubmit={onSave}
      />
    </div>

    <div className="padded">
      <h2>{t('Uložené správy')}</h2>
      <MessageList
        messages={messages}
        messagesFilter={messagesFilter}
        isLoading={isLoading}
        onFilterChange={onFilterChange}
      />
    </div>

    <div className="padded">
      <h2>{t('Položené otázky')}</h2>
      <QuestionList
        questions={questions}
        isLoadingQ={isLoadingQ}
      />
    </div>
  </React.Fragment>
);

AccountMessages.propTypes = {
  onSave: PropTypes.func.isRequired,
  messages: PropTypes.array.isRequired,
  questions: PropTypes.array.isRequired,
  messagesFilter: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(AccountMessages);



// WEBPACK FOOTER //
// ./src/features/account-management/components/AccountMessages.js